import React from "react";

export const LogoIcon = () => (
  // tslint:disable:max-line-length
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="70"
    height="38"
    viewBox="0 0 70 38"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#00AC69"
        fillRule="nonzero"
        d="M51.5 35C60.042 35 67 27.854 67 19S60.042 3 51.5 3 36 10.146 36 19s6.958 16 15.5 16zm0 3C41.283 38 33 29.493 33 19S41.283 0 51.5 0 70 8.507 70 19s-8.283 19-18.5 19z"
      />
      <circle cx="19" cy="19" r="19" fill="#00AC69" />
      <path
        fill="#00AC69"
        fillRule="nonzero"
        d="M52.739 20.5H35.304a1.5 1.5 0 0 1 0-3h17.435l-3.878-4.524a1.5 1.5 0 0 1 2.278-1.952l5.985 6.982A1.49 1.49 0 0 1 57.5 19a1.496 1.496 0 0 1-.376.994l-5.985 6.982a1.5 1.5 0 0 1-2.278-1.952L52.74 20.5z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M17.261 20.5l3.878 4.524a1.5 1.5 0 0 1-2.278 1.952l-5.985-6.982A1.49 1.49 0 0 1 12.5 19a1.495 1.495 0 0 1 .376-.994l5.985-6.982a1.5 1.5 0 0 1 2.278 1.952L17.26 17.5h18.437a1.5 1.5 0 0 1 0 3H17.26z"
      />
    </g>
  </svg>
);
